export interface INavTheme {
  background: string;
  backgroundFragment: string;
  font: string;
  accent: string;
  shadow: string;
}

export const LIGHT_MODE: INavTheme = {
  background: 'rgb(250, 250, 250)', // Semi-transparent white
  backgroundFragment: '250, 250, 250',
  font: 'rgba(0, 0, 0, 0.85)',
  accent: 'rgba(82, 146, 241, 1)', // Example primary accent color
  shadow: '1px 1px 1px 0px rgba(0,0,0,0.1)',
};

export const DARK_MODE: INavTheme = {
  background: 'rgb(61, 61, 66)', // Semi-transparent black
  backgroundFragment: '61, 61, 61',
  font: 'rgba(255, 255, 255, 0.85)',
  accent: 'rgb(139, 179, 240)', // Example primary accent color
  shadow: '1px 1px 1px 0px rgba(0,0,0,0.1)',
};
